export * from "./trust-html.module";
export * from "./trust-html.pipe";
